const TRANSLATE_OFFSET = 8;
export const getTranslate3d = (placement) => {
    const normalizedPlacement = placement.split("-")[0];
    switch (normalizedPlacement) {
        case "top":
            return { x: 0, y: TRANSLATE_OFFSET };
        case "bottom":
            return { x: 0, y: -TRANSLATE_OFFSET };
        case "left":
            return { x: TRANSLATE_OFFSET, y: 0 };
        case "right":
            return { x: -TRANSLATE_OFFSET, y: 0 };
        default:
            return { x: 0, y: 0 };
    }
};
export const getTransformOrigin = (placement) => {
    switch (placement) {
        case "top":
            return "50% 100%";
        case "top-start":
            return "0 100%";
        case "top-end":
            return "100% 100%";
        case "bottom":
            return "50% 0";
        case "bottom-start":
            return "0 0";
        case "bottom-end":
            return "100% 0";
        case "right":
            return "0 50%";
        case "right-start":
            return "0 0";
        case "right-end":
            return "0 100%";
        case "left":
            return "100% 50%";
        case "left-start":
            return "100% 0";
        case "left-end":
            return "100% 100%";
        case "auto":
        case "auto-start":
        case "auto-end":
        default:
            return "50%";
    }
};
